import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";

/**
 * Toast de SweetAlert2 configurado para notificaciones no intrusivas en la esquina superior
 */
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  }
});

/**
 * Inicia una exportación asíncrona sin bloquear la pantalla ni mostrar el spinner de carga.
 *
 * @param {String} entity Nombre de la entidad (ej: 'producto', 'keyword', 'operador', 'servicio', etc.)
 * @param {Object} params Filtros y parámetros (idIntegrador, orderBy, etc.)
 * @param {String} title Nombre legible para mostrar en las alertas (ej: 'Productos', 'Operadores')
 * @param {Number} idTarea ID opcional de la tarea en la tabla tareas
 * @returns {Promise}
 */
export function startAsyncExport(entity, params = {}, title = "", idTarea = null) {
  const displayTitle = title || entity.charAt(0).toUpperCase() + entity.slice(1);
  const apiUrl = process.env.VUE_APP_API_URL || "http://localhost:8000/";
  const appName = process.env.VUE_APP_NAME || "Panel";

  // Mostrar confirmación instantánea no bloqueante vía Toast
  Toast.fire({
    icon: "info",
    title: `Exportación de ${displayTitle} iniciada en segundo plano`,
    text: `Te avisaremos cuando esté lista. Puedes continuar usando ${appName}.`
  });

  return axios.post(
    `${apiUrl}export/async`,
    {
      entity,
      params,
      title: displayTitle,
      id_tarea: idTarea
    },
    {
      skipLoading: true,
      headers: {
        "X-Skip-Loading": "true"
      }
    }
  ).catch((error) => {
    console.error(`[startAsyncExport] Error al solicitar exportación de ${entity}:`, error);
    Toast.fire({
      icon: "error",
      title: `No se pudo iniciar la exportación de ${displayTitle}`
    });
    throw error;
  });
}
